<script lang="ts" setup>
import { reactive } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import { historicoVersoes } from "@/data/historicoVersoes";

const controle = reactive({
  aberto: historicoVersoes.length > 0 ? historicoVersoes[0].versao : null as string | null,
});

function alternar(versao: string) {
  controle.aberto = controle.aberto === versao ? null : versao;
}
</script>

<template>
  <BreadCrumb PageTitle="Histórico de Versões" SubTitle="Sistema" />

  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card" v-for="item in historicoVersoes" :key="item.versao">
    <div class="card-header" style="cursor: pointer;" @click="alternar(item.versao)">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <span class="badge bg-primary me-2">{{ item.versao }}</span>
          <span class="fw-bold">{{ item.titulo }}</span>
        </div>
        <i class="fa" :class="controle.aberto === item.versao ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>
    </div>
    <div class="card-body p-3" v-if="controle.aberto === item.versao">
      <ul class="mb-0">
        <li v-for="(texto, idx) in item.itens" :key="idx" class="mb-1">{{ texto }}</li>
      </ul>
    </div>
  </div>

  <div v-if="historicoVersoes.length === 0" class="text-center text-muted p-4">
    Nenhuma versão registrada ainda.
  </div>
</template>
